import { render, staticRenderFns } from "./InfosData.vue?vue&type=template&id=0c2c45cf&"
import script from "./InfosData.vue?vue&type=script&lang=js&"
export * from "./InfosData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports